function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendEmailCropped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    id: "Message_And_Communication_Icons",
    viewBox: "6.98 10.479999999999999 37.1 26.1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxHeight: 500
    },
    width: 37.1,
    height: 26.1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 30.1,
    x: 29,
    width: 13.2,
    style: {
      fill: "#002b49"
    },
    height: 3.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#002b49"
    },
    points: "38.8,20.3 42.3,18 42.3,33.3 38.8,33.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007dba"
    },
    d: "M41.6,32.6H16.4V16.1h25.2V32.6z M17.6,31.4h22.8V17.3H17.6V31.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#007dba"
    },
    points: "29,25 16.7,17.2 17.3,16.2 29,23.6 40.7,16.2 41.3,17.2"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 24.4,
    x: 13.9,
    width: 3.1,
    style: {
      fill: "#007dba"
    },
    height: 1.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 27.9,
    x: 10.7,
    width: 6.3,
    style: {
      fill: "#007dba"
    },
    height: 1.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 31.4,
    x: 7.6,
    width: 9.5,
    style: {
      fill: "#007dba"
    },
    height: 1.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 20.4,
    x: 10.8,
    width: 1.6,
    style: {
      fill: "#007dba"
    },
    height: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmailCropped);
export default __webpack_public_path__ + "static/media/send_email-cropped.c9ca958069eab6b103b11ec55b2b9137.svg";
export { ForwardRef as ReactComponent };